import React, { createContext, useContext } from "react";

const TrackingContext = createContext({
  trackEvent: () => {}, // Fallback: No-op function
});

export const useTracking = () => {
  return useContext(TrackingContext);
};

export const TrackingProvider = ({ children }) => {
  const isBrowser = typeof window !== "undefined";
  const isDevelopment = process.env.NODE_ENV === 'development';

  const trackEvent = (eventName, eventData = {}) => {
    // Skip tracking in development mode
    if (isDevelopment) {
      console.log('Development mode - would track:', eventName, eventData);
      return;
    }

    if (isBrowser && window.umami && typeof window.umami.track === "function") {
      console.log('Tracking event:', eventName, eventData); // Debug log
      window.umami.track(eventName, eventData);
    } else {
      console.log('Umami not available, would track:', eventName, eventData); // Debug log
    }
  };

  return (
    <TrackingContext.Provider value={{ trackEvent }}>
      {children}
    </TrackingContext.Provider>
  );
};